export const AUTH_PATHS = {
  confirmSignUp: '/confirm-sign-up',
  passwordReset: `/password-reset`,
  signIn: `/`,
  signUp: `/sign-up`
} as const;
